import React from "react";
import { testCaseIndexReducer, Actions, suiteTreeReducer } from "./reducer";
import {
  testCaseIndexState,
  TestCaseIndex,
  SuiteContext,
  suiteState
} from "./entity";
const TestCaseManageContext = React.createContext<TestCaseIndex>(
  testCaseIndexState
);
const SuiteTreeContext = React.createContext<SuiteContext>(suiteState);
export {
  testCaseIndexReducer,
  testCaseIndexState,
  SuiteTreeContext,
  suiteTreeReducer,
  SuiteContext,
  Actions,
  TestCaseManageContext
};
